import axios from "axios";

export const $api = axios.create()

$api.interceptors.request.use((config) => {
    config.headers["Key"] = "xplIYYVVzjZBFAAdXKbBgUpRExO-rBJnf6nxxo5q5xu-ShFUoyUejo7pPAil7u-BIiSkHyqpu88vd0IbPGQaXB_zFUPCpkngXFfr";
    return config;
})